import create from 'zustand'
import { devtools } from 'zustand/middleware'
import polish from '../languages/polish'
import english from '../languages/english'

const store = (set, get) => ({
    language: polish,
    isMobile: false,
    checkWindowSize: () => {
        window.innerWidth <= 750 ? set((state) => ({isMobile: true})) : set((state) => ({isMobile: false}))
    },
    changeLanguage: (newLang) => {
        switch(newLang){
            case 'pl':
                set((state) => ({language: polish}))
                break;
            case 'en':
                set((state) => ({language: english}))
                break;
            default: 
                console.log('Nie ma takiego języka')
                break;
        }
    },
    checkLocation: () => {
        try{
            if(navigator.language !== "pl-PL"){
                set((state) => ({language: english}))
            }
        }catch(err){
            console.log(err)
        }
    }
})

const optionsStore = create(devtools(store))

export default optionsStore